import "./menuaccordion.css";
// import WebInfoContext from "../../../context/WebInfo/WebInfoContext.ts";
import WebInfoContext from "../../../../../context/WebInfo/WebInfoContext.ts";
import Accordion from "react-bootstrap/Accordion";
import { FiChevronDown } from "react-icons/fi";
import { useContext } from "react";
import { pathMaker } from "../../../../../utils/helperFunctions";
import { NavLink } from "react-router-dom";

function MenuAccordion({setShowMenu}) {
  const webInfo = useContext(WebInfoContext);
  return (
    <Accordion className="menu_accordion pd-x-0">
      {webInfo?.categorys.map((val, ind) => {
        if (val.hashtag.type == 0 || val.hashtag.type == 1){
        return (
          <Accordion.Item eventKey={val.hashtag.id}>
            <Accordion.Header className="menu_accordion-title">
              <div className="menu_acc-tit">
                <span>
                  {" "}
                  {/* <img
                    className="wh-20 digi_Category-icon"
                    src={pathMaker(val.hashtag.icon)}
                  /> */}
                </span>
                <span style={{ marginRight: "6px" }}>{val.hashtag.txt}</span>
                <FiChevronDown
                  size={20}
                  color="#3f4064"
                  className="menu_acc-icon"
                />
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <div className="menu_acc-body">
                {val.subs.length > 0 ? (
                  <div className="menu_all_cat">
                    {val?.subs?.map((sub, indSub) => {
                      return (
                        <NavLink
                        className="text-decoration-none"
                          to={`/category/${val.hashtag.id}?sub=${sub.id}`}
                          onClick={()=>{setShowMenu(false)}}
                        >
                          <div
                            style={{
                              fontSize: "12px",
                              cursor: "pointer",
                              lineHeight: "40px ",
                              color:"#3F4064",
                              
                            }}
                          >
                            {sub.txt}
                          </div>
                        </NavLink>
                      );
                    })}
                  </div>
                ) : (
                  <div
                    style={{
                      fontSize: "12px",
                      cursor: "pointer",
                      lineHeight: "40px ",
                    }}
                  >
                    آیتمی وجود ندارد.
                  </div>
                )}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        )};
      })}
    </Accordion>
  );
}

export default MenuAccordion;
